import React, { useEffect, useState } from "react";
import dialHandleImage from "@/assets/dial-full-pink-x2.png";
import "./styles.scss";

const Dial = ({
  value = 0,
  maxValue = 9,
  spacing = "equalSpaced",
  onChange,
  tips = [],
}) => {
  const RADIUS_DISTANCE = 130;

  const getStartingAngle = (total) => {
    if (total <= 10) return 0;
    return 30;
  };

  const getSpacingAngle = (total) => {
    if (spacing === "adjacent") {
      const arcLength = 50;
      return (arcLength / RADIUS_DISTANCE) * (180 / Math.PI);
    }

    const totalArc = 260; // Total arc remains constant for equal spacing
    return totalArc / (total - 1); // Divide by (total - 1) to include first and last positions
  };

  const getPosition = (index, total) => {
    const startAngle = getStartingAngle(total);
    const anglePerItem = getSpacingAngle(total);
    const angleInDegrees = startAngle + anglePerItem * index;
    const angleInRadians = (angleInDegrees * Math.PI) / 180;

    const x = RADIUS_DISTANCE * Math.cos(angleInRadians);
    const y = RADIUS_DISTANCE * Math.sin(angleInRadians);

    return {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`,
    };
  };

  const handleCircleClick = (raceNumber) => {
    if (onChange) {
      onChange(raceNumber.toString());
    }
  };

  const renderListItems = () => {
    if (value <= 0) return null;

    return (
      <div className="dial-circle-outer z-50 relative">
        <ul>
          {[...Array(maxValue)].map((_, index) => {
            const raceNumber = index + 1;
            const isActive = raceNumber === parseInt(value);

            return (
              <li
                key={`R${raceNumber}`}
                className={isActive ? "active" : ""}
                style={getPosition(index, maxValue)}
                onClick={() => handleCircleClick(raceNumber)}
                data-gtm-element-id={`todays-tips_race-dial_button-${raceNumber}`}
              >
                {isActive ? (
                  <span className="circle-number">R{raceNumber}</span>
                ) : (
                  ""
                )}
                {isActive ? (
                  <span className="circle-background"></span>
                ) : (
                  <span className="circle-background-inactive"></span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  const getHandleRotation = () => {
    if (spacing === "adjacent") {
      const arcLength = 50;
      const radius = RADIUS_DISTANCE;
      const anglePerItem = Math.round((arcLength / radius) * (180 / Math.PI));
      const clickedIndex = parseInt(value) - 1;
      return Math.round(12 + anglePerItem * clickedIndex);
    }

    const anglePerItem = Math.round(260 / (maxValue - 1));
    const clickedIndex = parseInt(value) - 1;
    return Math.round(18 + anglePerItem * clickedIndex);
  };

  const getMaskRotation = () => {
    if (spacing === "adjacent") {
      const arcLength = 50;
      const radius = RADIUS_DISTANCE;
      const anglePerItem = Math.round((arcLength / radius) * (180 / Math.PI));
      const clickedIndex = parseInt(value) - 1;
      return Math.round(110 + anglePerItem * clickedIndex);
    }

    const anglePerItem = Math.round(260 / (maxValue - 1));
    const clickedIndex = parseInt(value) - 1;
    return Math.round(110 + anglePerItem * clickedIndex);
  };

  const getMaskGradient = () => {
    const anglePerItem = Math.round(260 / (maxValue - 1));
    const clickedIndex = parseInt(value) - 1;
    const endAngle = Math.round(110 - anglePerItem * clickedIndex);
    const startAngle = endAngle + 140;

    if (spacing === "adjacent") {
      return `conic-gradient(from 0deg,transparent ${startAngle}deg,transparent ${endAngle}deg,#fff 0deg, rgba(255, 255, 255, 1) 354deg, rgba(255, 255, 255, 0) 360deg))`;
    }

    return `conic-gradient(from 0deg,transparent ${startAngle}deg,transparent ${endAngle}deg,#fff 0deg, rgba(255, 255, 255, 1) 354deg, rgba(255, 255, 255, 0) 360deg)`;
  };

  return (
    <div className="dial-component">
      <div className="dial-circle">
        {renderListItems()}
        <div className="tips-dial-inner z-8">
          <ul>
            {tips &&
              tips.length > 0 &&
              tips.map((tip, index, rank) => (
                <li key={index} className="tip-item">
                  <span className="horse-hash">#{tip.rank}</span>
                  <span className="horse-number">{tip.number}.</span>
                  <span className="horse-name">{tip.name}</span>
                </li>
              ))}
            {tips && tips.length === 0 && (
              <li className="tip-item no-tips">
                <strong>Sorry!</strong> <br />
                No tips for <br />
                this race
              </li>
            )}
          </ul>
        </div>
        <div className="dial-drag-handle z-6 relative">
          <div
            className="dial-mask absolute inset-0"
            style={{
              WebkitMaskImage: getMaskGradient(),
              maskImage: getMaskGradient(),
              transform: `rotate(${getMaskRotation()}deg)`,
              transition: "transform 0.3s ease-in-out",
            }}
          >
            <div
              className="dial-drag-handle-inner"
              style={
                {
                  // transform: `rotate(${getHandleRotation()}deg)`,
                  // transition: 'transform 0.3s ease-in-out'
                }
              }
            >
              <img src={dialHandleImage} alt="Dial drag handle" />
            </div>
          </div>
        </div>
        <div className="dial-circle-inner z-4"></div>
        <div className="dial-circle-inner-large z-1"></div>
      </div>
    </div>
  );
};

export default Dial;
